function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { AccessToken as BaseAccessToken, ensure } from 'buzz_lib_shared';
export class AccessToken extends BaseAccessToken {
  static fromStorageOrDefault() {
    ensure(window, 'This method is for use only in browser.');
    const storedAccessTokenRaw = window.sessionStorage.getItem(AccessToken.SESSION_STORAGE_KEY);
    const storedAccessToken = storedAccessTokenRaw ? JSON.parse(storedAccessTokenRaw) : undefined;
    return storedAccessToken ? new AccessToken(storedAccessToken.value) : undefined;
  }
  static fromStorage() {
    const storedAccessToken = AccessToken.fromStorageOrDefault();
    ensure(storedAccessToken, "Access token (".concat(AccessToken.SESSION_STORAGE_KEY, ") is missing. Make sure you are authenticated."));
    return storedAccessToken;
  }
  static clearStorage() {
    ensure(window, 'This method is for use only in browser.');
    window.sessionStorage.removeItem(AccessToken.SESSION_STORAGE_KEY);
  }

  /**
   * Time until token expiration from Date.now shortened by renewal offset (in milliseconds)
   */
  get timeToRenewalMs() {
    const renewelOffsetMs = AccessToken.RENEWAL_OFFSET_SECONDS * 1000;
    return this.timeToExpirationMs - renewelOffsetMs;
  }
  get isCloseToRenewal() {
    return this.timeToRenewalMs <= 0;
  }
  constructor(accessToken) {
    super(accessToken);
  }
  store() {
    ensure(window, 'This method is for use only in browser.');
    const valueToStore = {
      value: this.encodedAccessToken
    };
    window.sessionStorage.setItem(AccessToken.SESSION_STORAGE_KEY, JSON.stringify(valueToStore));
  }
}
_defineProperty(AccessToken, "SESSION_STORAGE_KEY", 'access_token');
_defineProperty(AccessToken, "RENEWAL_OFFSET_SECONDS", 300);